import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { IMultisiteItem } from '@df/core/service/multisite';
import { TimeoutService } from '@df/ng/timeout.service';
import { Basket } from '@df/session/api/basket/basket';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
import { DfModalService } from '@df/ui/modal/df-modal.service';
import { MultisiteSwitchComponentDef } from '@df/ui/multisite/multisite-switch.component.def';
import { ToggleModule } from '@df/ui/toggle/toggle.module';
import { ICmsBlockResource } from '@icms/core/resource/block/icms-block.resource';
import { NBasketCarryOverModal } from '../../basket/carry-over/basket-carry-over-modal.component';
import { MultisiteFlagComponent } from '../flag/multisite-flag.component';
import { TradeClassDirective } from '../trade/trade-class.directive';
import { TradeStoreService } from '../trade/trade-store.service';
@Component({
    selector: 'multisite-switch',
    templateUrl: './multisite-switch.component.html',
    styleUrls: ['./multisite-switch.component.scss'],
    standalone: true,
    imports: [ToggleModule, MultisiteFlagComponent, TradeClassDirective, SizeClassDirective],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MultisiteSwitchComponent extends MultisiteSwitchComponentDef {
    @Input()
    dropDown = false;
    readonly toggleId = 'multisite-switch';
    constructor(
        ref: ChangeDetectorRef,
        timeoutService: TimeoutService,
        private tradeStoreService: TradeStoreService,
        private dfModalService: DfModalService,
        private basket: Basket,
        private iCmsBlockResource: ICmsBlockResource
    ) {
        super(ref, timeoutService);
    }
    get sites(): IMultisiteItem[] {
        return this.tradeStoreService.isTradeStore() ? this.tradeStoreService.tradeSites : this.tradeStoreService.retailSites;
    }

    get hideSelector(): boolean {
        return !this.sites.filter(site => site.siteId !== this.multisiteService.current.siteId)?.length;
    }

    override async goTo(siteId: number | string, $event: Event) {
        const block = (await this.iCmsBlockResource.retrieve(
            { bareUrl: NBasketCarryOverModal.blockId, createOnError: true },
            undefined
        )) as NBasketCarryOverModal.Block;
        const content = block?.data?.content;
        if (
            content &&
            !content.styles?.hidden &&
            this.basket.items.length &&
            this.multisiteService.toMultisiteItem(siteId)?.siteId !== this.multisiteService.siteId
        ) {
            try {
                await this.dfModalService.open(undefined, NBasketCarryOverModal.blockId, undefined, {
                    variant: 'canCarry',
                    siteId,
                    $event
                });
            } catch (e) {
                super.goTo(siteId, $event);
            }
        } else {
            super.goTo(siteId, $event);
        }
    }
}
